import {DataKey} from '../../stores/GeneralSelectorTableStore';
import * as React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import onClickOutside from 'react-onclickoutside';
import {observable} from 'mobx';
import {observer} from 'mobx-react';
import {stylesheet} from 'typestyle';
import {ToggleableSelectorTableColumnDef} from '../types/Report';
import {LightGreyColor, WhiteColor} from '../../styles/colors';

interface ColumnPickerProps {
    idParentBuildingBlock: string;
    updateTableColumnVisibility: (idTableBuildingBlock: string, dataKey: DataKey, visibility: boolean) => void;
    columns: ToggleableSelectorTableColumnDef[];
}

@observer
class ColumnPicker extends React.Component<ColumnPickerProps> {
    @observable private pickerMenuVisible = false;

    public handleClickOutside = (e: React.MouseEvent<HTMLElement>): void => {
        this.pickerMenuVisible = false;
    };

    private renderPickerFoldout(): React.ReactNode {
        const {columns} = this.props;

        return (
            <div className={columPickerCss.foldoutMenu}>
                {columns.map((column) => (
                    <div
                        key={column.dataKey}
                        className={columPickerCss.columnLine}
                        onClick={() => {
                            this.props.updateTableColumnVisibility(this.props.idParentBuildingBlock, column.dataKey, !column.isVisible);
                        }}>
                        <input readOnly type="checkbox" checked={column.isVisible} className={columPickerCss.pickerCheckbox} />
                        <div>{column.label}</div>
                    </div>
                ))}
            </div>
        );
    }

    private onPickerMenuClick = (_: React.MouseEvent) => {
        this.pickerMenuVisible = true;
    };

    public render() {
        return (
            <button className={columPickerCss.columPickerButton} onClick={this.onPickerMenuClick}>
                <FontAwesomeIcon icon="cog" transform="shrink-2" />
                {this.pickerMenuVisible ? this.renderPickerFoldout() : null}
            </button>
        );
    }
}

const columPickerCss = stylesheet({
    pickerCheckbox: {
        marginRight: 15,
    },
    columnLine: {
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        padding: 5,
    },
    foldoutMenu: {
        backgroundColor: WhiteColor,
        position: 'absolute',
        top: 34,
        right: 0,
        padding: 10,
        border: '1px solid ' + LightGreyColor,
        maxHeight: 400,
        overflow: 'auto',
        minWidth: 180,
        zIndex: 5,
    },
    columPickerButton: {
        position: 'relative',
        backgroundColor: 'transparent',
        border: '1px solid ' + LightGreyColor,
        borderRight: 'none',
    },
});

export default onClickOutside(ColumnPicker);



// WEBPACK FOOTER //
// ./src/report/views/ColumnPicker.tsx